export const CoreActionTypes = {
    SET_CURRENT_PAGE_NAME: "@@core/SET_CURRENT_PAGE_NAME",
}

export interface CoreState {
    readonly currentPageName: string
}
